<template>
  <LayoutGradient :title="$t('dexpara.exame_resultado.titulo_pagina')" icon="fa-random" :content-overflow="false">
    <b-card-group class="m-3 mt-n10 bg-transparent border-0" body-class="p-0" deck>
      <b-card class="col-md-9" body-class="p-0">
        <DeXParaSimpleFilter @search="searchResults"/>

        <TableSimple
            :fields="fields"
            :items="results"
            :loading="isLoading || DeXParaIsLoading"
            :paginator="pagination"
            :text-empty="$t('dexpara.exame_resultado.empty')"
            thead-class="h5 text-center"
            @paginate="paginateResults"
            borderless
            marginless
            hover
        >
          <template v-slot:cell(origin)="linha">
            <form-group-float-label
                :label="linha.item.name"
                :input-name="`input-origem-${linha.index}`"
                :disabled="!integrationsSelected.origin"
                v-model="linha.item.origin_code"
                mandatory
            />
            <b-button size="sm" variant="link" @click="openLogs(linha);" class="mb-0 p-0" v-if="permissions.includes('logs.detail')">
              {{ $t('dexpara.filtros.logs') }}
            </b-button>
          </template>
          <template v-slot:cell(destination)="{index, item}">
            <form-group-float-label
                :label="item.name"
                :input-name="`input-destino-${index}`"
                :disabled="!integrationsSelected.destination"
                v-model="item.destination_code"
                mandatory
            />
          </template>
          <template #row-details="{ item, index }">            
            <b-card :title="$t('dexpara.log.origem')">
              <b-card-text v-if="logItems[index] && logItems[index].logOrigin">
                {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logOrigin.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logOrigin.updated_at)}}.
              </b-card-text>
              <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
              <button v-if="logItems[index] && logItems[index].logOrigin" class="btn btn-outline-info" @click="openHistory(logItems[index].logOrigin.auditable_id)">Ver Histórico</button>
            </b-card>
            <b-card :title="$t('dexpara.log.destino')" class="mt-2">
              <b-card-text v-if="logItems[index] && logItems[index].logDestination">
                {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logDestination.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logDestination.updated_at)}}.
              </b-card-text>
              <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
              <button v-if="logItems[index] && logItems[index].logDestination" class="btn btn-outline-info" @click="openHistory(logItems[index].logDestination.auditable_id)">Ver Histórico</button>
            </b-card>
          </template>
        </TableSimple>
      </b-card>

      <DeXParaIntegrations class="col-md-3 sticky-top h-100" @change="updateIntegrations" @save="persistDeXPara">
        <template v-slot:options>
          <b-form-group :label="$t('dexpara.exame_resultado.exame')">
            <SelectTuevsExam @input="evt => {exam = evt; searchDeXparas();}" class="mb-3"/>
          </b-form-group>
        </template>
      </DeXParaIntegrations>

    </b-card-group>
  </LayoutGradient>
</template>

<script>
import {hasPerfil, getPermissionsFromActualPerfil} from '@/acl';
import LayoutGradient from "@/templates/LayoutGradient";
import {mapActions, mapGetters, mapMutations} from 'vuex';
import TableSimple from "@/components/TableSimple";
import FormGroupFloatLabel from "@/components/FormGroupFloatLabel";
import DeXParaIntegrations from "@/pages/dexpara/components/DeXParaIntegrations";
import DeXParaRepository from "@/repositories/dexpara/ExamResultRepository";
import DeXParaSimpleFilter from "@/pages/dexpara/components/DeXParaSimpleFilter";
import SelectTuevsExam from "@/components/tuevs/Select/SelectTuevsExam";
import AuditRepository from "@/repositories/audit/AuditRepository";
import moment from "moment";

export default {
  name: "DeXParaExameResultado",
  components: {
    SelectTuevsExam,
    DeXParaSimpleFilter,
    DeXParaIntegrations,
    TableSimple,
    FormGroupFloatLabel,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      filters: 'dexpara/filters',
      results: 'tuevs/examresult/all',
      isLoading: 'tuevs/examresult/isLoading',
      pagination: 'tuevs/examresult/pagination',

      DeXParas: 'dexpara/examresult/all',
      DeXParaIsLoading: 'dexpara/examresult/isLoading'
    })
  },
  data() {
    return {
      integrationsSelected: {
        origin: null,
        destination: null
      },
      exam: null,
      fields: [
        {key: 'origin', label: this.$t('dexpara.exame_resultado.origem'), tdClass: 'w-50'},
        {key: 'destination', label: this.$t('dexpara.exame_resultado.destino'), tdClass: 'w-50'}
      ],
      logItems: [],
      permissions: [],
      canAccessRoot: false
    }
  },
  methods: {
    ...mapActions([
      'integration/search',
      'dexpara/examresult/listAll',
      'tuevs/examresult/listAllPaginated'
    ]),
    ...mapMutations([            
            'dexpara/resetFilters'
    ]),
    async openLogs(linha) {
      if (linha.detailsShowing === false) {
        this.logItems[linha.index] = await this.formatLogDetails(linha.item);
      }      

      linha.toggleDetails();
    },
    async formatLogDetails(examResult) {
      let obj = {}
      let logOrigin = null
      let logDestination = null

      if (!this.DeXParas || this.DeXParas.length === 0) {
        return obj
      }

      let originMapped = this.DeXParas.filter(d => d.tuevs_exam_result_id === examResult.id && d.mapping_exam_result_code === examResult.origin_code);
      let destinationMapped = this.DeXParas.filter(d => d.tuevs_exam_result_id === examResult.id && d.mapping_exam_result_code === examResult.destination_code);

      if (originMapped && originMapped.length > 0) {
        logOrigin = await AuditRepository.getLastByModelId(originMapped[0].mapping_exam_result_id).then(async (response) => {          
          return response.data.data;          
        })
      }

      if (destinationMapped && destinationMapped.length > 0) {
        logDestination = await AuditRepository.getLastByModelId(destinationMapped[0].mapping_exam_result_id).then(async (response) => {
          return response.data.data;
        })
      }

      obj.logOrigin = logOrigin;
      obj.logDestination = logDestination;
      return obj
    },
    openHistory(auditId) {
      const routeData = this.$router.resolve({ name: 'logs.detail', params: { id: auditId } });
      window.open(routeData.href, '_blank');
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY HH:mm:ss');
    },
    async paginateResults(pagination) {
      await this.$store.commit('tuevs/examresult/setPagination', {
        ...this.pagination,
        page: pagination.page,
        per_page: pagination.per_page
      })
      await this.searchResults()
    },
    async searchResults() {
    let filterApi = [...this.filters];
      let hasIntegrationFilter = filterApi.some(f => f[0] === "integration");
      let hasCodeFilter = filterApi.some(f => f[0] === "code_mapping");

      if (!hasIntegrationFilter && hasCodeFilter) {
        if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
          filterApi.push(['integration', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]);
        }
      }
      
      await this['tuevs/examresult/listAllPaginated']({
        ...this.pagination,
        filters: filterApi,
        order_by: 'name'
      })
      await this.searchDeXparas()
    },
    async searchDeXparas() {
      let filters = [
        ['tuevs_exam_result_id', 'IN', this.results.reduce((accumulator, current) => [...accumulator, current.id], [])],
        ['vns_integration_id', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]],
        ['tuevs_exam_id', '=', (this.exam ? this.exam.value : null)]
      ]
      if (this.exam && (this.integrationsSelected.origin || this.integrationsSelected.destination)) {
        await this['dexpara/examresult/listAll']({filters})
        await this.loadIntegrationsCodes()
      }
    },
    getDeXpara(tuevs_valor_id, integration_id) {
      if (this.DeXParas && Array.isArray(this.DeXParas)) {
        return this.DeXParas.find(valor => {
          return valor.vns_integration_id === integration_id &&
              valor.tuevs_exam_result_id === tuevs_valor_id &&
              valor.tuevs_exam_id === this.exam.value
        })
      }
      return null
    },
    async loadIntegrationsCodes() {
      if (this.results && Array.isArray(this.results)) {
        const valores = this.results.map(valor => {
          const origin_mapped = this.getDeXpara(valor.id, this.integrationsSelected.origin)
          valor.origin_code = origin_mapped ? origin_mapped.mapping_exam_result_code : null

          const destination_mapped = this.getDeXpara(valor.id, this.integrationsSelected.destination)
          valor.destination_code = destination_mapped ? destination_mapped.mapping_exam_result_code : null

          return valor
        })
        this.$store.commit('tuevs/examresult/setAll', valores)
      }
    },
    async updateIntegrations(evt) {
      this.integrationsSelected.origin = this.integrationsSelected.destination = null

      let originLabel = this.$t('dexpara.exame_resultado.origem')
      if (evt.origin) {
        originLabel = evt.origin.label
        this.integrationsSelected.origin = evt.origin.value
      }

      let destinationLabel = this.$t('dexpara.exame_resultado.destino')
      if (evt.destination) {
        destinationLabel = evt.destination.label
        this.integrationsSelected.destination = evt.destination.value
      }

      this.fields = [
        {key: 'origin', label: originLabel},
        {key: 'destination', label: destinationLabel}
      ]
      await this.searchDeXparas()
    },
    async persistDeXPara() {
      let parsedInserts = []
      let parsedUpdates = []

      if (!this.exam) {
        this.$snotify.warning(this.$t('dexpara.exame_resultado.selecione_exame'))
        return
      }

      if (this.integrationsSelected.origin) {
        let integrationId = this.integrationsSelected.origin
        this.results.filter(e => e.origin_code !== null)
            .map(valor => {
              let dexpara = {
                vns_integration_id: integrationId,
                tuevs_exam_id: this.exam.value,
                tuevs_exam_result_id: valor.id,
                code: valor.origin_code
              }
              let DeXPara = this.getDeXpara(valor.id, integrationId)
              if (DeXPara) {
                dexpara = {...dexpara, id: DeXPara.mapping_exam_result_id}
                if (valor.origin_code === ''){
                  dexpara = {...dexpara, code: DeXPara.mapping_exam_result_code, delete: true}
                }
                parsedUpdates.push(dexpara)
                return
              }
              parsedInserts.push(dexpara)
            })
      }

      if (this.integrationsSelected.destination) {
        let integrationId = this.integrationsSelected.destination
        this.results.filter(v => v.destination_code !== null)
            .map(valor => {
              let dexpara = {
                vns_integration_id: integrationId,
                tuevs_exam_id: this.exam.value,
                tuevs_exam_result_id: valor.id,
                code: valor.destination_code
              }
              let DeXPara = this.getDeXpara(valor.id, integrationId)
              if (DeXPara) {
                dexpara = {...dexpara, id: DeXPara.mapping_exam_result_id}
                if (valor.destination_code === ''){
                  dexpara = {...dexpara, code: DeXPara.mapping_exam_result_code, delete: true}
                }
                parsedUpdates.push(dexpara)
                return
              }
              parsedInserts.push(dexpara)
            })
      }

      if (parsedInserts.length > 0) {
        parsedInserts.map(async dexpara => {
          await DeXParaRepository.post(dexpara)
        })
        this.$snotify.success(this.$t('dexpara.exame_resultado.depara_sucesso'))
        await this.searchResults()
      }

      if (parsedUpdates.length > 0) {
        parsedUpdates.map(async params => {
          await DeXParaRepository.put(params.id, params)
        })
        this.$snotify.success(this.$t('dexpara.exame_resultado.depara_sucesso'))
        await this.searchResults()
      }
    }
  },
  async beforeMount() {
    this['dexpara/resetFilters']()
    this.permissions = await getPermissionsFromActualPerfil();
    this.canAccessRoot = await hasPerfil('root');
  },
  async mounted() {
    await this.$store.commit('tuevs/examresult/setPagination', {...this.pagination, page: 1})
    this['integration/search']()
    await this.searchResults()
  }
}
</script>

<style lang="scss" scoped>
.sticky-top {
  top: 1.5rem;

  @media only screen and(max-width: 768px) {
    order: -1;
  }
}
</style>
